import { Component, Input, OnInit } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { CommonModule } from '@angular/common';
import { UpgradeModule } from '@angular/upgrade/static';
import { GiftCardTheme } from '@src/app/core/models/campaigns.model';
import { CampaignsService } from '@src/app/shared/services/ib-gift-cards-campaigns/ib-gift-cards-campaigns.service';
import { IbGiftCardsContributionService } from '@src/app/features/pages/contribution/services/ib-gift-cards-contribution/ib-gift-cards-contribution.service';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';


@Component({
    standalone: true,
    imports: [CommonModule, UpgradeModule, TranslateModule, ReactiveFormsModule],
    selector: 'ib-gift-cards-contribution-card-component',
    templateUrl: './ib-gift-cards-contribution-card-component-view.html'
})


export class ibGiftContributionCardComponent implements OnInit { 
    amount;
    @Input() form!: FormGroup;

    public isLongPrice: boolean;
    public expirationDate: string;
    public code: string;
    public theme: string;

    protected viewModel: GiftCardTheme;

    constructor (
        private CampaignsService: CampaignsService,
        public contributionService: IbGiftCardsContributionService
    ) {
        this.expirationDate = this.contributionService.contributionDataResponse?.deliveryDate?.split(' ')[0];
        this.code = contributionService.getParameterByName('code');
        this.theme = contributionService.contributionDataResponse.theme;
    }

    ngOnInit (): void {
        this.buildTheme(this.theme);
    }

    buildTheme (newTheme: string): void {
        this.CampaignsService.buildCardViewModel(newTheme)
            .then(viewModel => {
                this.viewModel = viewModel;
            });
    }
    checkIfLongPrice = () => {
        this.isLongPrice = this.contributionService.contributionDataResponse.amount.toString.length >= 9;
    };
}